import React, { useState } from 'react';
import { TAB_OPTIONS } from './tabOptions';
import { SnapButton } from '../../SnapButton';

export default function Tabs({
  onTabSelected,
}: {
  onTabSelected: (index: number) => void;
}): React.JSX.Element {
  const [selectedIndex, setSelectedIndex] = useState(0);
  return (
    <div>
      {TAB_OPTIONS.map((to, index) => (
        <SnapButton
          key={index}
          onClick={() => {
            setSelectedIndex(index);
            onTabSelected(index);
          }}
          className={`${selectedIndex === index ? 'font-bold' : ''}}`}
        >
          {to.name}
        </SnapButton>
      ))}
    </div>
  );
}
